<template>
  <div class="safety-control">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/safety-control/banner.png" />
    </div>
    <div class="safety-platform">
      <div class="website-container">
        <h2>基于工业物联网+AI技术的有色加工企业智能安全管控一体化平台</h2>
        <div class="safety-platform-intro">
          <span class="platform-item-1 item-title">人的不安全行为辨识</span>
          <span class="platform-item-2 item-des">安全帽识别、高空作业人员安全带未正确佩戴、进入危险区域识别、抽烟报警、姿态识别、单独作业警示等</span>
          <span class="platform-item-3 item-title">设备不安全状态监控</span>
          <span class="platform-item-4 item-des">运用AI技术分析异常监控视频和图像，及时对异常行为或状态进行报警</span>
          <span class="platform-item-5 item-title">危险区域设定与监控</span>
          <span class="platform-item-6 item-des">管理区域内人员信息、设备信息、厂区地图信息、具体参数设置并进行消息推送</span>
          <span class="platform-item-7 item-title">安全规范管理</span>
          <span class="platform-item-8 item-des">风险分级管控、完善隐患排查治理体系，形成安全风险四色分布图，将安全生产的关口前移</span>
          <span class="platform-item-9 item-title">数据智能分析</span>
          <span class="platform-item-10 item-des">运用AI技术分析异常监控视频和图像，及时对异常行为或状态进行报警</span>
          <span class="platform-item-11 item-title">信息发布与管理</span>
          <span class="platform-item-12 item-des">管理区域内人员信息、设备信息、厂区地图信息、具体参数设置并进行消息推送</span>
          <span class="platform-item-center">基于物联网+AI的工厂安全管控平台</span>
        </div>
        <img alt src="@/assets/images/website/solution/safety-control/part_2.png" />
      </div>
    </div>
    <div class="safety-education">
      <div class="website-container">
        <h2>
          建立安全教育培训系统
          <span>(全流程从入职到离职)</span>
        </h2>
        <Row class="ivu-row ivu-row-space-between">
          <Col span="9">
            <img alt src="@/assets/images/website/solution/safety-control/part_3.png" />
          </Col>
          <Col class="safety-education-right" span="14">
            <div class="education-function ivu-row ivu-row-space-between">
              <span>接收安全教育培训</span>
              <span style="background-color: #4592D5;">熟悉安全生产规章制度</span>
              <span>熟悉安全操作规程</span>
            </div>
            <div class="education-function ivu-row ivu-row-space-around">
              <span style="background-color: #4592D5;">具备安全生产知识</span>
              <span>掌握安全操作技能</span>
            </div>
            <div class="education-function ivu-row ivu-row-space-between">
              <span>增强预防事故能力</span>
              <span style="background-color: #4592D5;">增强控制职业危害能力</span>
              <span>增强应急处理能力</span>
            </div>
          </Col>
        </Row>
        <Row style="height:200px;">
          <Col class="bottom-col-item1" span="8">
            <span>
              <b>建立安全教育培训档案（全流程从入职到离职），</b>涵盖：姓名、岗位、性别、学历、年龄、入职时间、教育培训情况、考试情况等信息。
            </span>
          </Col>
          <Col class="bottom-col-item2" span="8">
            <span>
              培训和考试内容根据岗位可直接
              <b>推送到手机端</b>
            </span>
          </Col>
          <Col class="bottom-col-item3" span="8">
            <span>
              系统自动记录培训和考试情况，并统计相关信息，
              <b>制作报表</b>
            </span>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="less" scoped>
.solution-banner {
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.safety-platform {
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  img {
    width: 100%;
    margin-top: 40px;
  }
  .safety-platform-intro {
    position: relative;
    height: 536px;
    background: url('~@/assets/images/website/solution/safety-control/part_1.png') center center
      no-repeat;
    .platform-item-1 {
      position: absolute;
      left: 130px;
      top: 6px;
    }
    .platform-item-2 {
      position: absolute;
      left: 30px;
      top: 70px;
      width: 400px;
    }
    .platform-item-3 {
      position: absolute;
      left: 130px;
      top: 197px;
    }
    .platform-item-4 {
      position: absolute;
      left: 30px;
      top: 260px;
      width: 400px;
    }
    .platform-item-5 {
      position: absolute;
      left: 130px;
      top: 397px;
    }
    .platform-item-6 {
      position: absolute;
      left: 30px;
      top: 460px;
      width: 400px;
    }
    .platform-item-7 {
      position: absolute;
      right: 200px;
      top: 7px;
    }
    .platform-item-8 {
      position: absolute;
      right: 26px;
      top: 70px;
      width: 400px;
    }
    .platform-item-9 {
      position: absolute;
      right: 200px;
      top: 196px;
    }
    .platform-item-10 {
      position: absolute;
      right: 26px;
      top: 260px;
      width: 400px;
    }
    .platform-item-11 {
      position: absolute;
      right: 190px;
      top: 396px;
    }
    .platform-item-12 {
      position: absolute;
      right: 26px;
      top: 460px;
      width: 400px;
    }
    .platform-item-center {
      position: absolute;
      font-size: 22px;
      color: #0c1b34;
      font-weight: bold;
      left: 600px;
      top: 220px;
      width: 100px;
    }
    .item-title {
      font-size: 20px;
      font-weight: bold;
      color: #174088;
    }
    .item-des {
      font-size: 14px;
      color: #666666;
    }
  }
}
.safety-education {
  background: linear-gradient(#f6f7f9, #ffffff);
  margin-top: 40px;
  margin-bottom: 30px;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
    span {
      font-size: 16px;
      font-weight: bold;
    }
  }
  img {
    width: 100%;
  }
  .safety-education-right {
    margin: auto 0;
    align-items: center;
    justify-content: center;
  }
  .education-function {
    margin-bottom: 40px;
    span {
      padding: 15px 15px;
      background-color: #6d9cc5;
      border-radius: 5px;
      color: #ffffff;
      font-size: 16px;
    }
  }
  .bottom-col-item1 {
    padding: 40px 30px 40px 100px;
    background: url('~@/assets/images/website/solution/safety-control/part_4_1.png') center center
      no-repeat;
    margin: auto 0;
  }
  .bottom-col-item2 {
    margin: auto 0;
    padding: 40px 40px 40px 110px;
    background: url('~@/assets/images/website/solution/safety-control/part_4_2.png') center center
      no-repeat;
  }
  .bottom-col-item3 {
    padding: 40px 40px 40px 110px;
    background: url('~@/assets/images/website/solution/safety-control/part_4_3.png') center center
      no-repeat;
    margin: auto 0;
  }
  .bottom-col-item1,
  .bottom-col-item2,
  .bottom-col-item3 {
    span {
      b {
        font-size: 16px;
        color: #184188;
      }
    }
  }
}
</style>
